import React, { useEffect, useState } from "react";
import { t } from "i18next";
import { useParams, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import FixedFooter from "components/FixedFooter";
import PageHeader from "components/PageHeader";
import TrackOrderFooter from "components/track-order/TrackOrderFooter";
import StepTracking from "components/track-order/StepTracking";
import TrackOrderHeader from "components/track-order/TrackOrderHeader";
import TrackOrderStatus from "components/track-order/TrackOrderStatus";
import { OrderAction } from "store/actions";
import { UTILS } from "utils";
import { Spinner } from "components";
import { ErrorComponent } from "components";
import C from "Constants";
import { useCustomHistory } from "hooks";
import WithMap from "components/Hoc/WithMap";

function TrackOrderSlider(props) {
  const dispatch = useDispatch();
  const [status, setStatus] = useState(1);
  const params = useParams();
  const history = useHistory();
  const { isLoading } = useSelector((state) => state?.loader);
  const { loading } = useSelector((state) => state?.brand);
  const { orderStatus, orderInfo, error } = useSelector((state) => state.order);
  const { DomainType } = useSelector((state) => state.AppReducer);
  const router = useCustomHistory();
  const [mapref, setMapRef] = useState(null);


useEffect(() => {
    if (params?.orderId) {
      if (params?.domainName && DomainType === C.TEMPORARY_DOMAIN) {
        const orderId = params.orderId;
        const obj = {
          orderId,
          history,
        };
        dispatch(OrderAction.getOrderStatus(obj));
      } else {
        const orderId = params.orderId;
        const obj = {
          orderId,
          history,
        };
        dispatch(OrderAction.getOrderStatus(obj));
      }
    }
  }, []);

  const getOrderStatus = (orderInfo) => {
    if (orderInfo) {
      const status = UTILS.getOrderStatus(orderInfo);
      if (status)
        return <StepTracking orderStatus={orderStatus} orderInfo={orderInfo} />;
      else
        return (
          <TrackOrderStatus orderStatus={orderStatus} orderInfo={orderInfo} />
        );
    }
  };
  const goBack = () => {
    router("/", `/${params?.domainName}`, DomainType);
  };

  if (isLoading || loading) return <Spinner />;
  return (
    <div className="create-address h-screen bg-white">
      <PageHeader
        pageHeaderClasses="flex justify-between  border-black-100 px-4 w-full shadow-sm relative"
        title={t("Track Your Order")}
        url={true}
        handleClick={goBack}
      />

      <div className="flex flex-col flex-grow text-15x">
        <div className="flex flex-col flex-grow h-full py-7 px-4">
          <div className="flex flex-col flex-grow h-full">
            <TrackOrderHeader
              orderStatus={orderStatus}
              orderInfo={{...orderInfo , deliveryTime:orderInfo?.slider_delivery?.estimated_delivery_time}}
              status={status}
            />
            <hr className="my-4 border-gray-200" />
            {orderInfo?.slider_delivery?.driver_info ? <div className="w-full bg-gray-100 h-56">
              <WithMap
                className="map-height"
                width="100%"
                showInput={false}
                mapref={mapref}
                setMapRef={setMapRef}
                zoomChanging={false}
                height="224px"
                googlemapState={{
                  userLocation: {
                    lat: orderInfo?.slider_delivery?.driver_info.latitude,
                    lng: orderInfo?.slider_delivery?.driver_info.longitude,
                  },
                  zoom: 6,
                  mapAddress: "",
                }}
                zoomerror={null}
                isZoomModalOpen={false}
                setZoomErrorModal={() => {}}
              />
            </div> : <div></div>}
            {orderInfo?.slider_delivery?.driver_info?.name ? (
              <div className="flex flex-col w-full mt-4">
                <div className="w-full text-gray-400 mb-1 font-bold text-21x leading-normal">
                  Delivery Guy Details
                </div>
                <div className="flex w-full justify-between">
                  <div className="w-10 h-10">
                    {orderInfo?.slider_delivery?.driver_info?.image ? (
                      <img
                        className="w-10 h-10"
                        src={orderInfo?.slider_delivery?.driver_info?.image}
                        alt="Driver"
                      />
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd" viewBox="0 0 512 512.337"><path fill="#194794" fill-rule="nonzero" d="M318.647 319.401c17.395 38.715 58.464 45.55 93.095 52.245C462.398 381.432 512 429.266 512 483.478v22.094c0 3.725-3.04 6.765-6.775 6.765H6.775c-3.735 0-6.775-3.04-6.775-6.765v-19.988c0-65.14 52.682-103.616 105.911-110.739 38.724-5.175 70.951-10.431 84.581-57.241 3.527 3.089 7.233 6.208 11.008 9.566 35.277 31.363 75.025 32.724 109.01-.049 2.792-2.703 5.524-5.246 8.137-7.72z"/><path fill="#D2A75F" fill-rule="nonzero" d="M318.647 319.411c9.1 20.247 24.677 31.781 42.409 39.122-59.984 44.01-142.797 41.466-204.49 3.855 18.687-10.064 28.045-24.638 33.907-44.795 3.526 3.09 7.242 6.21 11.027 9.577 35.277 31.363 75.025 32.724 109.01-.049 2.792-2.703 5.524-5.246 8.137-7.71z"/><path fill="#DBB26F" fill-rule="nonzero" d="M259.328 391.058c-35.873.159-71.955-9.895-102.762-28.67 18.617-10.024 28.214-24.826 33.916-44.795 3.537 3.09 7.233 6.21 11.018 9.577 18.528 16.472 38.307 24.667 57.828 23.992v39.896z"/><path fill="#E9BE79" d="M134.739 212.161c4.655-13.324 15.482-9.04 30.904-3.412l-.142-.666.142.075c11.004-115.475 85.398-49.193 141.122-109.957 29.279 14.418 48.212 43.104 43.366 107.067l.156-.124a280.937 280.937 0 01-1.534 10.001c14.023-10.621 34.241-9.633 27.882 13.905l-8.687 24.605c-2.077 5.889-3.466 8.027-10.91 7.627-3.288-.175-6.595-1.443-9.894-3.622 3.046 36.31-14.579 48.157-36.64 69.449-33.977 32.787-73.728 31.433-108.995.059-20.658-18.375-39.004-29.534-39.92-67.307-5.356 1.641-10.42 1.939-14.842-.575-8.814-5.016-12.024-19.614-12.505-28.962-.193-3.759-.032-14.335.497-18.163z"/><path fill="#F2CD8C" d="M134.741 212.161c4.66-13.326 15.477-9.036 30.903-3.411l-.138-.665.138.075c8.039-84.405 49.947-71.713 93.68-82.493V351.16c-19.515.683-39.287-7.506-57.817-23.992-20.657-18.374-39.005-29.529-39.914-67.305-5.356 1.637-10.422 1.937-14.843-.577-12.837-7.306-13.871-33.724-12.009-47.125z"/><path fill="#333231" d="M108.075 92.791C176.124 8.703 254.558-37.032 313.452 37.772c72.174 3.79 97.211 121.553 36.678 167.497 4.849-63.963-14.086-92.651-43.364-107.067-55.725 60.764-130.12-5.52-141.122 109.955l-26.707-13.909c-2.652-33.119 5.106-90.577-30.862-101.457z"/></svg>
                    )}
                  </div>
                  <div className="flex flex-col">
                    <div>Name: {orderInfo?.slider_delivery?.driver_info?.name}</div>
                    <div>Contact: {orderInfo?.slider_delivery?.driver_info?.phone_number}</div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="p-4 text-center font-bold text-22x">
                Delivery is on the way!
              </div>
            )}
          </div>
        </div>
        {error && <ErrorComponent error={error} />}
        <TrackOrderFooter orderStatus={orderStatus} orderInfo={orderInfo} />
        <FixedFooter />
      </div>
    </div>
  );
}

export default TrackOrderSlider;
